import React from 'react';
import { useLocation } from 'react-router-dom';
import AppSuspense from '../AppSuspense';
import AppErrorBoundary from '../AppErrorBoundary';
import {StyledMainContentView} from './index.styled';

type AppContentViewProps = {
  routes: React.ReactElement | null;
  isBureau?: boolean; // Thêm isBureau vì khi nhúng vô old ui của bureau cần override css
  fullBleed?: boolean; // standalone full-page routes (e.g. /oauth/authorize) → no content padding
};

const AppContentView: React.FC<AppContentViewProps> = ({routes, isBureau, fullBleed}) => {
  const location = useLocation();
  return (
    <StyledMainContentView className={isBureau ? 'bureau' : ''} $fullBleed={fullBleed}>
      <AppSuspense>
        <AppErrorBoundary key={location.pathname}>{routes}</AppErrorBoundary>
      </AppSuspense>
    </StyledMainContentView>
  );
};

export default AppContentView;
